if (!customElements.get('interactive-card')) {
  customElements.define('interactive-card', class extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-card-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.sizeList = this.querySelector('[data-size-list]');
      this.atcBtn   = this.querySelector('[data-atc]');
      this.selectedVariant = null;

      /* Couleur initiale via l'ID de variante porté par la card — fiable à 100% */
      this.selectedColor = this.colorFromVariantId(this.dataset.variantId);

      /* Card non cliquable : on neutralise tous les liens */
      this.querySelectorAll('a').forEach(a =>
        a.addEventListener('click', e => e.preventDefault())
      );

      /* Sélection couleur via l'ID de variante du swatch cliqué */
      this.querySelectorAll('color-swatch').forEach(sw => {
        sw.addEventListener('click', () => {
          const color = this.colorFromVariantId(sw.dataset.variantId);
          if (color) this.selectedColor = color;
          this.selectedVariant = null;
          this.renderSizes();
        });
      });

      this.atcBtn?.addEventListener('click', () => this.addToCart());
      this.renderSizes();
      this.initSwatchScroller();
    }

    colorFromVariantId(id) {
      if (!id) return null;
      const v = this.variants.find(v => String(v.id) === String(id));
      return v ? v.option1 : null;
    }

    variantsForColor() {
      /* Filtre strict par option1 ; si rien, retombe sur la 1re couleur — jamais tout */
      let list = this.variants.filter(v => v.option1 === this.selectedColor);
      if (!list.length && this.variants.length) {
        this.selectedColor = this.variants[0].option1;
        list = this.variants.filter(v => v.option1 === this.selectedColor);
      }
      return list;
    }

    renderSizes() {
      if (!this.sizeList || !this.atcBtn) return;
      const vs = this.variantsForColor();
      const hasSize = vs.some(v => v.option2);
      this.atcBtn.hidden = true;
      this.atcBtn.disabled = false;

      /* Produit mono-option (pas de taille) → ATC direct */
      if (!hasSize) {
        this.sizeList.innerHTML = '';
        this.selectedVariant = vs.find(v => v.available && v.qty > 0) || null;
        if (this.selectedVariant) this.atcBtn.hidden = false;
        return;
      }

      this.sizeList.innerHTML = vs.map(v => {
        const ok = v.available && v.qty > 0;
        return `<button type="button"
          class="card-shop__size${ok ? '' : ' is-disabled'}"
          data-id="${v.id}" ${ok ? '' : 'disabled'}>${v.option2}</button>`;
      }).join('');

      this.sizeList.querySelectorAll('[data-id]').forEach(btn => {
        btn.addEventListener('click', () => {
          this.sizeList.querySelector('.is-selected')?.classList.remove('is-selected');
          btn.classList.add('is-selected');
          this.selectedVariant = this.variants.find(v => v.id == btn.dataset.id);
          this.atcBtn.hidden = false;
        });
      });

      /* Présélection : variante dispo avec le plus de stock (cf. maquette).
         L'ATC apparaît directement au hover, un clic taille change la sélection. */
      const best = vs.filter(v => v.available && v.qty > 0)
                     .sort((a, b) => b.qty - a.qty)[0];
      if (best) {
        const btn = this.sizeList.querySelector(`[data-id="${best.id}"]`);
        if (btn) {
          btn.classList.add('is-selected');
          this.selectedVariant = best;
          this.atcBtn.hidden = false;
        }
      }
    }

    // async addToCart() {
    //   if (!this.selectedVariant) return;
    //   this.atcBtn.disabled = true;
    //   const label = this.atcBtn.textContent;
    //   try {
    //     const res = await fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify({
    //         items: [{ id: this.selectedVariant.id, quantity: 1 }],
    //         sections: 'cart-icon-bubble'
    //       })
    //     });
    //     const data = await res.json();
    //     if (!res.ok) throw new Error(data.description || 'error');

    //     /* MAJ du compteur panier SANS ouvrir le drawer */
    //     if (data.sections?.['cart-icon-bubble']) {
    //       const bubble = document.getElementById('cart-icon-bubble');
    //       if (bubble) {
    //         const tmp = document.createElement('div');
    //         tmp.innerHTML = data.sections['cart-icon-bubble'];
    //         bubble.innerHTML = tmp.querySelector('#cart-icon-bubble')?.innerHTML ?? tmp.innerHTML;
    //       }
    //     }
    //     this.atcBtn.textContent = 'Ajouté ✓';
    //     setTimeout(() => {
    //       this.atcBtn.textContent = label;
    //       this.atcBtn.disabled = false;
    //     }, 1600);
    //   } catch (e) {
    //     this.atcBtn.textContent = 'Indisponible';
    //     setTimeout(() => {
    //       this.atcBtn.textContent = label;
    //       this.atcBtn.disabled = false;
    //     }, 1600);
    //   }
    // }
    async addToCart() {
      if (!this.selectedVariant) return;
      const label = this.atcBtn.textContent;
      this.atcBtn.disabled = true;
      this.atcBtn.textContent = 'Ajout…';   /* feedback immédiat, avant le réseau */
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: this.selectedVariant.id, quantity: 1 }],
            sections: 'cart-icon-bubble'
          })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'error');

        /* MAJ du compteur panier SANS ouvrir le drawer */
        if (data.sections?.['cart-icon-bubble']) {
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            const tmp = document.createElement('div');
            tmp.innerHTML = data.sections['cart-icon-bubble'];
            bubble.innerHTML = tmp.querySelector('#cart-icon-bubble')?.innerHTML ?? tmp.innerHTML;
          }
        }

        /* Prévenir le thème → le side cart se resynchronise immédiatement */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'interactive-card', cartData: data });
        }
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        this.atcBtn.textContent = 'Ajouté ✓';
        setTimeout(() => {
          this.atcBtn.textContent = label;
          this.atcBtn.disabled = false;
        }, 1600);
      } catch (e) {
        this.atcBtn.textContent = 'Indisponible';
        setTimeout(() => {
          this.atcBtn.textContent = label;
          this.atcBtn.disabled = false;
        }, 1600);
      }
    }

    /* Scroller swatches + compteur +N dynamique */
    initSwatchScroller() {
      const track = this.querySelector('.card__colors-track');
      const badge = this.querySelector('[data-more-count]');
      if (!track || !badge) return;
      const badgeWrap = badge.closest('span, button');

      const update = () => {
        const swatches = track.querySelectorAll('color-swatch');
        if (!swatches.length) { badgeWrap.hidden = true; return; }

        const unit = track.scrollWidth / swatches.length;   /* largeur moyenne d'un swatch */
        const remaining = track.scrollWidth - track.clientWidth - track.scrollLeft;

        /* Seuil = un demi-swatch : ignore les débordements décoratifs (ring is-active) */
        if (remaining < unit * 0.5) {
          badgeWrap.hidden = true;
          return;
        }
        badge.textContent = '+' + Math.max(Math.round(remaining / unit), 1);
        badgeWrap.hidden = false;
      };

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      badgeWrap.addEventListener('click', () =>
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' })
      );

      /* Recalcule quand le layout est prêt (CSS chargé, tailles connues) */
      requestAnimationFrame(update);
      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(track);
      }
    }
  });
}